import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  NewTable,
  TableAdv,
  ToolTip,
  useFormHandler,
} from "../../../../../../../components";
import {
  invoiceCalculationTypeOptions,
  invoiceFrequencyTypeOptions,
} from "../../../../../../../assets/data/projectData";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { Weekdays } from "../../../../../../../assets/data/enumData";
import { dateFormator, mapTableRows } from "../../../../../../../utils";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";

const InvoiceDetails = ({
  handleBack,
  onCancel,
  currentPlacement,
  editData,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        invoiceCalculationType: "",
        invoiceFrequency: "",
        frequencyStartDate: "",
        includePoNumber: "No",
        weekStartDay: "",
        funding: "No",
        ccEmail: [],
        appexCalander: [],
        additionalInfo: "",
      },
      {
        invoiceCalculationType: { type: "select", required: true },
        invoiceFrequency: { type: "select", required: true },
        frequencyStartDate: { type: "select", required: true },
      },
    );
  console.log({ formData });

  const ShowWeekStartDay =
    formData.invoiceFrequency === 1 || formData.invoiceFrequency === 2;

  const ShowAppexCalander = formData.invoiceFrequency === 6;

  const handleAddCalendar = () => {
    const newCalendar = {
      id: uuidv4(),
    };
    const updated = [...formData.appexCalander, newCalendar];
    handleChange("appexCalander", updated);
  };

  const handleRemoveCalendar = (id) => {
    const updated = formData.appexCalander.filter((item) => item.id !== id);
    handleChange("appexCalander", updated);
  };

  const handleCalendarChange = (id, key, value) => {
    const updated = formData.appexCalander.map((item) =>
      item.id === id ? { ...item, [key]: value } : item,
    );
    handleChange("appexCalander", updated);
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const invoices = {
        calcType: formData.invoiceCalculationType,
        frequency: formData.invoiceFrequency,
        frequencyStartDate: formData.frequencyStartDate,
        frequencyStartDay: formData?.weekStartDay,
        includePONum: formData.includePoNumber === "No" ? false : true,
        isFunded: formData.funding === "No" ? false : true,
        additionalInfo: formData.additionalInfo,
        cc: formData?.ccEmail || [],
      };
      const submissionData = filterEmptyValues(invoices);
      const uiid = fetchPerticularData?.uiid ?? "";
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "clientPlacementInvoice",
          payload: [
            {
              type: "SET",
              value: {
                invoices: {
                  ...submissionData,
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            handleBack();
          },
        }),
      );
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  const columns = [
    {
      key: "from",
      label: "From",
      render: (row) => dateFormator(row?.from, "month-day-year"),
    },
    {
      key: "to",
      label: "To",
      width: "180px",
      render: (row) => dateFormator(row?.to, "month-day-year"),
    },
  ];
  const tableData =
    Array.isArray(formData?.appexCalander) && formData.appexCalander.length > 0
      ? formData.appexCalander
      : [];

  const mappedRows = mapTableRows(tableData, columns);
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "jobInfo.startDate invoices apexDates uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          const invoices = data?.invoices || {};
          console.log({ invoices });
          setFetchPerticularData(data);
          // handleChange("calcType", invoices?.calcType);
          handleChange("invoiceCalculationType", invoices?.calcType);
          if (invoices?.frequencyStartDate) {
            handleChange("frequencyStartDate", invoices?.frequencyStartDate);
          } else {
            handleChange("frequencyStartDate", data?.jobInfo?.startDate);
          }
          handleChange(
            "funding",
            invoices?.isFunded === false
              ? "No"
              : invoices?.isFunded === true
                ? "Yes"
                : "",
          );
          handleChange(
            "includePoNumber",
            invoices?.includePONum === false
              ? "No"
              : invoices?.includePONum === true
                ? "Yes"
                : "",
          );
          handleChange("additionalInfo", invoices?.additionalInfo);
          handleChange("ccEmail", invoices?.cc || []);
          if (Array.isArray(data.apexDates)) {
            const apexDates = data.apexDates.flatMap((item) =>
              Object.entries(item)
                .filter(([key]) => !isNaN(key)) // Keep only numeric keys: "0", "1", etc.
                .map(([_, value]) => ({
                  from: value.from,
                  to: value.to,
                })),
            );
            const invoiceFrequency =
              invoices.cycles === 7 ? 6 : invoices?.frequency;

            handleChange("invoiceFrequency", invoiceFrequency);
            handleChange("appexCalander", apexDates);
            handleChange("weekStartDay", invoices?.frequencyStartDay);
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="w-full px-8 py-6 overflow-auto min-h-[62vh]">
    <div className="w-full px-8 py-6 overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6">
        <FormFieldSet
          type="select"
          title="Invoice Calculation Type"
          placeholder="Select Invoice Calculation Type"
          value={formData.invoiceCalculationType}
          onChange={(val) => handleChange("invoiceCalculationType", val)}
          error={errors.invoiceCalculationType}
          options={invoiceCalculationTypeOptions}
        />

        <FormFieldSet
          type="select"
          title="Invoice Frequency"
          placeholder="Select Invoice Frequency"
          value={formData.invoiceFrequency}
          onChange={(val) => {
            handleChange("invoiceFrequency", val);
            if (val !== 1 && val !== 2) {
              handleChange("weekStartDay", "");
            }
            // handleChange("appexCalander", [
            //   {
            //     id: uuidv4(),
            //     fromDate: "",
            //     toDate: "",
            //   },
            // ]);
          }}
          error={errors.invoiceFrequency}
          options={invoiceFrequencyTypeOptions}
        />

        {ShowWeekStartDay && (
          // <FormFieldSet
          //   type="datepicker"
          //   title="Week Start Day"
          //   placeholder="Select Week Start Day"
          //   value={formData.weekStartDay}
          //   onChange={(val) => handleChange("weekStartDay", val)}
          //   error={errors.weekStartDay}
          // />
          <FormFieldSet
            type="select"
            title={"Week Start Day"}
            placeholder="Select Week Start Day"
            value={formData.weekStartDay}
            onChange={(value) => handleChange("weekStartDay", value)}
            error={errors.weekStartDay}
            options={Weekdays}
          />
        )}

        <FormFieldSet
          type="datepicker"
          title="Frequency Start Date"
          placeholder="Select Frequency Start Date"
          value={formData.frequencyStartDate}
          onChange={(val) => handleChange("frequencyStartDate", val)}
          error={errors.frequencyStartDate}
          showDropdown={false}
        />
        {/* <div> */}
        {ShowAppexCalander && (
          // formData.appexCalander.map((item) => (
          //   <div key={item.id} className="flex item-center gap-4">
          //     <div className="flex-1">
          //       <FormFieldSet
          //         type="datepickerRange"
          //         title="Choose Date"
          //         placeholder="Select From and To Date"
          //         value={item.fromDate}
          //         onChange={(val) =>
          //           handleCalendarChange(item.id, "fromDate", val)
          //         }
          //         disabled={true}
          //       />
          //     </div>
          //   </div>
          // ))
          <>
            <div>
              <span className="text-[12px] font-medium mb-0.5 ">
                appexCalander
              </span>
              <div className="p-1 border-[1px] border-neutrals-200 max-h-32 overflow-auto">
                <TableAdv tableId={`employee_placement_addclientplacement_invoices_invoicedetails`} columns={columns} rows={mappedRows} hideToolBar />
              </div>
            </div>
          </>
        )}
        {/* </div> */}
        <FormFieldSet
          type="radio"
          title="Include PO Number"
          options={[
            { label: "Yes", value: "Yes" },
            { label: "No", value: "No" },
          ]}
          value={formData.includePoNumber}
          onChange={(e) => handleChange("includePoNumber", e.target.value)}
          error={errors.includePoNumber}
          name="Include PO Number"
        />

        <div className="col-span-1">
          <FormFieldSet
            type="radio"
            title="Funding/Non-funding"
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
            value={formData.funding}
            onChange={(e) => handleChange("funding", e.target.value)}
            error={errors.funding}
            name="Funding/Non-funding"
          />
        </div>
        {formData?.funding === "Yes" && (
          <>
            <div className="col-span-1">
              {/* <FormFieldSet
              type="radio"
              title="additionalInfo"
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              value={formData.funding}
              onChange={(e) => handleChange("funding", e.target.value)}
              error={errors.funding}
              name="Funding/Non-funding"
            /> */}
              <FormFieldSet
                type="textArea"
                title="Additional Info"
                value={formData.additionalInfo}
                onChange={(value) => handleChange("additionalInfo", value)}
                error={errors.additionalInfo}
              />
            </div>
            <div>
              <FormFieldSet
                type="email"
                title={
                  <ToolTip
                    size="sm"
                    description={"Please type and enter"}
                    color="primary"
                  >
                    <span className="mr-1">CC Email ID</span>
                  </ToolTip>
                }
                placeholder="Enter CC Email ID"
                value={formData.ccEmail}
                onChange={(value) => handleChange("ccEmail", value)}
                multiple
                error={errors.ccEmail}
              />
            </div>
          </>
        )}
      </div>

      <div className="flex gap-3 justify-end mt-4">
        <Button title="Cancel" variant="outlined" onClick={handleCancel} />
        <Button title="Save" onClick={handleSave} />
      </div>
    </div>
  );
};

export default InvoiceDetails;
